<lib-list-page
    [host]="this"
    title="Runners"
    icon="memory"
    searchPlaceholder="Search runners…"
    [activeChips]="activeFilterChips()"
    (chipRemove)="removeFilterChip($event)"
    totalIcon="memory"
    totalLabel="Runners"
    emptyStateIcon="memory"
    emptyStateTitle="No runners registered"
    emptyStateSubtitle="When a runner JVM boots it publishes a registration event over Kafka and shows up here. If you expect one, check that the concrete runner is up and reaching tasksense.runner.registry.">

    <ng-container actions>
        <button mat-icon-button (click)="refreshData(true)" matTooltip="Refresh" aria-label="Refresh">
            <mat-icon>refresh</mat-icon>
        </button>
    </ng-container>

    <ng-container filters>
        <div class="filter-select-box">
            <div class="filter-context-label">
                <mat-icon class="filter-context-icon">toggle_on</mat-icon>
                Status
                <span class="filter-active-count" *ngIf="filter().status !== 'ALL'">1</span>
            </div>
            <div class="status-toggle-group">
                <button class="status-toggle-btn"
                        [class.active]="filter().status === 'ALL'"
                        (click)="setStatusFilter('ALL')">All</button>
                <button class="status-toggle-btn"
                        [class.active]="filter().status === 'ONLINE'"
                        (click)="setStatusFilter('ONLINE')">
                    <span class="status-dot active-dot"></span> Online
                </button>
                <button class="status-toggle-btn"
                        [class.active]="filter().status === 'STALE'"
                        (click)="setStatusFilter('STALE')">
                    <span class="status-dot blocked-dot"></span> Stale
                </button>
            </div>
        </div>
    </ng-container>

    <table mat-table table [dataSource]="dataSource()" class="full-width-table" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let r">
                <span class="runner-status-pill"
                      [class.online]="!isStale(r)"
                      [class.stale]="isStale(r)">
                    <mat-icon class="status-pill-icon">{{ isStale(r) ? 'cloud_off' : 'check_circle' }}</mat-icon>
                    {{ isStale(r) ? 'Stale' : 'Online' }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
            <td mat-cell *matCellDef="let r">
                <div class="name-line">
                    <strong>{{ r.name || r.host }}</strong>
                    <span class="container-pill" *ngIf="r.containerized === true"
                          [matTooltip]="containerTooltip(r)">
                        <mat-icon>inventory_2</mat-icon>
                    </span>
                </div>
                <div class="cell-sub" *ngIf="r.name">{{ r.host }} · pid {{ r.pid }}</div>
                <div class="cell-sub" *ngIf="!r.name">pid {{ r.pid }}</div>
                <div class="cell-sub runner-id-mono">{{ r.runnerId }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="endpoint">
            <th mat-header-cell *matHeaderCellDef>Endpoint</th>
            <td mat-cell *matCellDef="let r">
                <span *ngIf="r.ip && r.port">{{ r.ip }}:{{ r.port }}</span>
                <span *ngIf="r.ip && !r.port">{{ r.ip }}</span>
                <span *ngIf="!r.ip" class="endpoint-unbound">—</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="domain">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="domain">Domain</th>
            <td mat-cell *matCellDef="let r">{{ r.domain || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="capabilities">
            <th mat-header-cell *matHeaderCellDef>Capabilities</th>
            <td mat-cell *matCellDef="let r">{{ formatList(r.tags) || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="connectors">
            <th mat-header-cell *matHeaderCellDef>Connectors</th>
            <td mat-cell *matCellDef="let r">{{ formatList(r.connectors) || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="maxConcurrency">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="maxConcurrency">Slots</th>
            <td mat-cell *matCellDef="let r">{{ r.maxConcurrency }}</td>
        </ng-container>

        <ng-container matColumnDef="runnerVersion">
            <th mat-header-cell *matHeaderCellDef>Version</th>
            <td mat-cell *matCellDef="let r">{{ r.runnerVersion || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="lastSeen">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="lastSeen">Last Seen</th>
            <td mat-cell *matCellDef="let r">{{ r.lastSeen | date: 'medium' }}</td>
        </ng-container>

        <ng-container matColumnDef="registeredAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="registeredAt">Registered</th>
            <td mat-cell *matCellDef="let r">{{ r.registeredAt | date: 'medium' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="clickable-row"
            (click)="onRowClick(row)"></tr>
    </table>

</lib-list-page>
